"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HistoryList = void 0;
require("./HistoryList.scss");
var _core = require("@dragon/core");
var _return = _interopRequireDefault(require("./return.svg"));
var _replay = _interopRequireDefault(require("./replay.svg"));
var _blitz = _interopRequireDefault(require("./blitz.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * None iframe viewing of rounds, allow for ingame replay.
 * 
 * Its either this or the iframe version that can be used in game.
 * 
 */
var HistoryList = exports.HistoryList = /*#__PURE__*/function () {
  function HistoryList(parent) {
    _classCallCheck(this, HistoryList);
    _defineProperty(this, "wrapper", void 0);
    _defineProperty(this, "table", void 0);
    _defineProperty(this, "headerRow", void 0);
    _defineProperty(this, "roundDetails", void 0);
    _defineProperty(this, "detailsContainer", void 0);
    _defineProperty(this, "_loader", void 0);
    _defineProperty(this, "_message", void 0);
    _defineProperty(this, "tableHeader", void 0);
    _defineProperty(this, "tableBody", void 0);
    this.wrapper = document.createElement("div");
    // this.wrapper.innerHTML = "HERE BE WRAPPER"
    this.wrapper.className = "history-wrapper";
    parent.appendChild(this.wrapper);
    this.table = document.createElement("table");
    this.table.setAttribute("cellspacing", "0");
    this.table.className = "history-table";
    this.wrapper.appendChild(this.table);
    this.table.classList.add("hide");
    this.tableHeader = document.createElement("thead");
    this.headerRow = document.createElement("tr");
    this.tableHeader.appendChild(this.headerRow);
    this.table.appendChild(this.tableHeader);
    this.addTableHeader(this.headerRow, "time");
    this.addTableHeader(this.headerRow, "bet");
    this.addTableHeader(this.headerRow, "win");
    this.addTableHeader(this.headerRow, "empty"); // used for icons.

    parent.appendChild(this.wrapper);
    this.tableBody = document.createElement("tbody");
    this.table.appendChild(this.tableBody);
    //#region test instead of modal

    this.roundDetails = document.createElement('div');
    this.roundDetails.id = "roundDetails";
    this.detailsContainer = document.createElement('div');
    this.detailsContainer.id = "details-container";
    var detailsClose = document.createElement('span');
    detailsClose.innerHTML = _return["default"];
    detailsClose.className = "details-close";
    this.roundDetails.appendChild(detailsClose);
    detailsClose.onclick = this.closeDetails.bind(this);
    this.wrapper.appendChild(this.roundDetails);
    this.roundDetails.appendChild(this.detailsContainer);
    this.roundDetails.classList.add("hide");

    //#endregion
    this._loader = document.createElement("div");
    this._loader.className = "lds-ring";
    this._loader.innerHTML = "<div></div><div></div><div></div><div></div>";
    this.wrapper.appendChild(this._loader);
    this._message = document.createElement("div");
    this._message.className = "message";
    this._message.classList.add("hide");
    this.wrapper.appendChild(this._message);
  }
  return _createClass(HistoryList, [{
    key: "refresh",
    value: function refresh() {
      var _this = this;
      this.roundDetails.classList.add("hide");
      this.clear();
      var state = _core.CORE.getState();
      this._loader.classList.remove("hide");
      fetch(state.config.historyUrl.replace("{gameId}", state.config.gameId).replace("{playerId}", state.config.playerId).replace("{locale}", state.config.locale).replace("{iId}", state.config.iId.toString()), {
        method: "GET",
        headers: {
          Accept: "application/json"
        }
      }).then(function (d) {
        if (d.ok) {
          _this._loader.classList.add("hide");
          _this.table.classList.remove("hide");
          d.json().then(function (data) {
            data.forEach(function (element) {
              _this.addDataRow(element, state);
            });
          });
        } else {
          _this._message.classList.remove("hide");
          _this._message.innerHTML = _core.CORE.translate("hhfail") + ' (1)';
          _this._loader.classList.add("hide");
        }
      })["catch"](function (e) {
        //  this._loader.classList.add("hide")
        _this._message.classList.remove("hide");
        _this._message.innerHTML = _core.CORE.translate("hhfail") + ' (2)';
        _this._loader.classList.add("hide");
      })["finally"](function () {
        _this._loader.classList.add("hide");
      });
    }
  }, {
    key: "rowClick",
    value: function rowClick(e) {
      var _this2 = this;
      var id = e.target.parentElement.getAttribute("data-id");
      if (!id) return;
      this.table.classList.add("hide");
      this._loader.classList.remove("hide");
      var c = document.getElementById("details-container");
      var state = _core.CORE.getState();
      fetch(state.config.historyUrl.split('?')[0] + "/ingame?roundId=" + id + "&gameId=" + state.config.gameId + "&locale=" + state.config.locale).then(function (response) {
        // The API call was successful!
        return response.text();
      }).then(function (html) {
        // This is the HTML from our response as a text string
        _this2.roundDetails.classList.remove("hide");
        _this2.table.classList.add("hide");
        c.innerHTML = html;
      })["catch"](function (err) {
        // There was an error
        _this2._message.classList.remove("hide");
        _this2._message.innerHTML = "Failed to round details. Please try again later.";
      })["finally"](function () {
        _this2._loader.classList.add("hide");
      });
    }
  }, {
    key: "closeDetails",
    value: function closeDetails() {
      this.roundDetails.classList.add("hide");
      this.table.classList.remove("hide");
    }
  }, {
    key: "addDataRow",
    value: function addDataRow(d, store) {
      var _d$metaData;
      var row = document.createElement('tr');
      //row.className = "row"; this causes a clash with other css.
      row.setAttribute("data-id", d.id);
      row.setAttribute("data-balance", d.balance);
      row.setAttribute("data-played", d.played);
      row.onclick = this.rowClick.bind(this);
      var td1 = document.createElement('td');
      td1.innerHTML = (0, _core.dateFormatter)(d.played);
      row.appendChild(td1);
      var td2 = document.createElement('td');
      td2.innerHTML = (0, _core.currencyFormatter)(d.loss, d.currency, undefined, undefined, true);
      row.appendChild(td2);
      var td3 = document.createElement('td');
      td3.innerHTML = (0, _core.currencyFormatter)(d.win, d.currency, undefined, undefined, true);
      row.appendChild(td3);
      var td4 = document.createElement('td');
      var iconContainer = document.createElement('div');
      iconContainer.className = "history-icon-container";
      td4.appendChild(iconContainer);
      if (store.config.ire) {
        var rDiv = document.createElement('div');
        rDiv.className = "history-replay-icon";
        rDiv.setAttribute("title", "Replay the round");
        rDiv.innerHTML += _replay["default"];
        iconContainer.appendChild(rDiv);
        rDiv.onclick = this.replayclick.bind(this);
      }
      if ((_d$metaData = d.metaData) !== null && _d$metaData !== void 0 && _d$metaData.blitz) {
        var bDiv = document.createElement('div');
        bDiv.className = "history-blitz-icon";
        bDiv.setAttribute("title", "This round was played in Blitz Mode.");
        bDiv.innerHTML += _blitz["default"];
        iconContainer.appendChild(bDiv);
      }
      row.appendChild(td4);
      this.tableBody.appendChild(row);
    }
  }, {
    key: "replayclick",
    value: function replayclick(e) {
      // this is a bit of a hack...
      var id = e.target.closest('tr').getAttribute("data-id");
      if (!id) return;
      _core.CORE.dispatch({
        type: _core.REQUEST_DIALOG_STATE,
        payload: _core.DialogState.CLOSED
      });
      _core.CORE.dispatch({
        type: _core.REPLAY_ROUND,
        payload: {
          roundId: id
        }
      });
    }

    /**
     * Remove old data.
     */
  }, {
    key: "clear",
    value: function clear() {
      var last;
      while (last = this.tableBody.lastChild) this.tableBody.removeChild(last);
    }
  }, {
    key: "addTableHeader",
    value: function addTableHeader(row, name) {
      var header = document.createElement("th");
      header.className = "history-header name";
      header.innerHTML = _core.CORE.translate("hh" + name);
      row.appendChild(header);
    }
  }]);
}();
//# sourceMappingURL=HistoryList.js.map